import React from "react";

import Navigation from "../Navigation";
import ConnectionSpinner from "../ConnectionSpinner";
import ApplicationConfig from "../ApplicationConfig";
import ApplicationContinue from "../ApplicationContinue";
import { useSelector } from "react-redux";
import SlowNetworkWarning from "../SlowNetworkWarning";

export default function App() {
  const isInProgress = useSelector((store) => store.apiFetch.isInProgress);
  return (
    <ConnectionSpinner>
      {isInProgress && <SlowNetworkWarning />}
      <ApplicationConfig>
        <ApplicationContinue>
          <Navigation />
        </ApplicationContinue>
      </ApplicationConfig>
    </ConnectionSpinner>
  );
}
